import { render, staticRenderFns } from "./MatchesSubHeader.vue?vue&type=template&id=1f8d3e51&scoped=true&"
import script from "./MatchesSubHeader.vue?vue&type=script&lang=js&"
export * from "./MatchesSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./MatchesSubHeader.vue?vue&type=style&index=0&id=1f8d3e51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d3e51",
  null
  
)

export default component.exports